import React, { Fragment } from "react";

import Hero from "../components/Hero";
import Content from "../components/Content";

const Home = () => (
    <Fragment>
        <Hero />
        <p>Hello, World!</p>
    </Fragment>
);

export default Home;
